module.exports = __webpack_public_path__ + "static/media/dropdown_arrow_white.f5cd961c.svg";